import { ServiceFetch } from '../service-fetch'

export default class PointExpireListModel extends ServiceFetch {
    getPointExpireListBy = (data) => this.authFetch({
        url: 'point-expire-list/getPointExpireListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    
    getLastPointExpireList = (data) => this.authFetch({
        url: 'point-expire-list/getLastPointExpireList',
        method: 'POST',
        body: JSON.stringify(data),
    })
}